<template>
    <div>
        <b-field>
            <b-radio-button
                :disabled="disabled"
                class="is-expanded is-fullwidth"
                v-for="grade in grades"
                :key="grade.text"
                v-model="points"
                :native-value="grade.points">
                <span>{{ grade.text }}</span>
            </b-radio-button>
        </b-field>
    </div>
</template>

<script>
export default Vue.extend({
  props: {
    scoreBase: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      default: "points"
    },
    disabled: {
      type: Boolean,
      required: false
    },
    value: {
      required: true
    }
  },
  data() {
    return {
      points: 0
    };
  },
  watch: {
    value(value) {
      this.points = value;
    },
    points() {
      this.$emit("input", parseInt(this.points));
    }
  },
  mounted() {
    this.points = this.value;
  },
  computed: {
    grades() {
      let scale = [];

      switch (this.type) {
        case "binary": {
          scale.push({
            text: "Неправильно",
            points: 0
          });
          scale.push({
            text: "Правильно",
            points: this.scoreBase
          });
          break;
        }
        default: {
          for (let score in [...Array(11).keys()]) {
            scale.push({
              text: score,
              points: parseInt(score)
            });
          }
        }
      }

      return scale;

      //   return [
      //     { text: "неудовлетворительно", points: 0 },
      //     { text: "удовлетворительно", points: 60 },
      //     { text: "хорошо", points: 82 },
      //     { text: "отлично", points: 100 }
      //   ];
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/survey/AnswerScore.vue